import ChargingPlansList from './ChargingPlansList';
export default ChargingPlansList;
